import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// Hero and content images
import heroImg from "../../assets/9.jpg"; 
import contentImg from "../../assets/10.jpg"; 

// ✅ Local project images (7 images: lf11.jpg to lf77.jpg)
import img1 from "../../assets/lf11.jpg";
import img2 from "../../assets/lf22.jpg";
import img3 from "../../assets/lf33.jpg";
import img4 from "../../assets/lf44.jpg";
import img5 from "../../assets/lf55.jpg";
import img6 from "../../assets/lf66.jpg";
import img7 from "../../assets/lf77.jpg";

const projectImages = [img1, img2, img3, img4, img5, img6, img7];

const OfficeList = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[430px] relative flex items-center justify-start px-6 md:px-12"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">
            Home
          </p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">Office</h1>
        </motion.div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 space-y-6"
          initial={{ opacity: 0, x: 120 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Say goodbye to last-minute delays and congestion with our high-speed,
            energy-efficient lifts designed to keep your employees moving smoothly,
            even during peak hours.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Our cutting-edge EyeRIS app enables employees to book lifts from a
            calculated distance, minimizing wait times and ensuring quick and efficient
            travel to their destination floors. With our fast and reliable solutions,
            your workforce can be more productive than ever before.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Whether you’re in a modern, multi-storey building or a traditional executive office,
            our lift systems are suitable for all office types. Contact us today to let our
            team of experts help you find a cost-effective lift solution tailored to your
            specific space and needs. At WVT Elevators, we’re dedicated to delivering top-quality
            service and helping you optimize your office operations. Let us enhance your
            workplace efficiency and keep your employees on the move.
          </p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 w-full overflow-hidden rounded-2xl shadow-2xl"
          initial={{ opacity: 0, x: -120 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img
            src={contentImg}
            alt="Office Lift"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl"
          />
        </motion.div>
      </div>

      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10"
          initial={{ opacity: 0, y: -80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          SOME PROJECTS
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: -120 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <Slider {...sliderSettings}>
            {projectImages.map((img, idx) => (
              <motion.div
                key={idx}
                className="px-2"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
              >
                <img
                  src={img}
                  alt={`Project ${idx + 1}`}
                  className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
                />
              </motion.div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </div>
  );
};

export default OfficeList;
